import becomeAcustomer from "@GeriMed/Handlers/Accounts/BecomeAcustomer";
import themeColors, { themeFonts } from "@GeriMed/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

export interface BecomeCustomerFormStyles {
    wrapper?: InjectableCss;
    headingWrapper?: InjectableCss;
    headingText?: TypographyPresentationProps;
    formFieldGridItem?: GridItemProps;
    formFieldGridContainer?: GridContainerProps;
    buttonWrapper?: InjectableCss;
    button?: InjectableCss;
    formTextField?: InjectableCss;
}

export const becomeCustomerFormStyles: BecomeCustomerFormStyles = {
    wrapper: {
        css: css`
            background: #ffffff;
            border-radius: 10px;
            border: 2px solid #D5D5DB;
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
            width: 95%;
            max-width: 400px;
            margin: auto;
            float: right;
            [class*="GridOffset"] {
                padding: 4px 11px;
                width: 100% !important;
                margin: 0;
            }
            .become-a-customer-form input.form-field {
                border: none !important;
                background-color: ${themeColors.colorLightBlue} !important;
                height: 28px !important;
            }
            label {
                color: #000000;
            }
            .become-a-customer-form .form-field-error{
                background: white;
                color: red;
            }
            .success-msg{
                font-size: 14px;
                padding: 10px 0;
                color: #00a500;
            }
            .error-msg{
                font-size: 14px;
                padding: 10px 0;
                color: #f20a0a;
            }
            .become-a-customer-form div[class*="FormInputWrapper"]{
                margin-top: 0;
            }
            @media screen and (max-width: 1023px) {
                .become-a-customer-container .offer-info {
                    padding: 0;
                }
                .become-a-customer-container .customer-header {
                    padding: 24px 16px 24px;
                }
                .become-a-customer-container .offer-info h4,
                .become-a-customer-container .offer-info p {
                    padding: 0 0 16px;
                    margin: 0;
                }
                .become-a-customer-container > div > div:last-child > div > div {
                    float: none;
                }
            }
        `,
    },
    headingWrapper: {
        css: css`
            background: #1f497d;
            padding: 12px 15px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            text-align: center;
        `,
    },
    headingText: {
        css: css`
            color: white;
            font-size: 20px;
            font-family: ${themeFonts.fontFamilyLexendDeca};
        `,
    },
    formFieldGridContainer: {
        gap: 10,
        css: css`
        `
    },
    formFieldGridItem: {
        width: 12,
        css: css`
        
        `,
    },
    formTextField: {
        css: css`
            .form-field {
                border: none;
                background-color: #F2F7F9;
            }
        `,
    },
    buttonWrapper: {
        css: css`
            text-align: left;
            padding: 4px 16px 16px 16px;
        `,
    },
    button: {
        css: css`
            background: #f7941d;
            color: white;
            padding: 8px 15px;
            border-radius: 5px;
            font-size: 16px;
            min-height: auto;
            text-transform: initial;
        `,
    },
};

const styles = becomeCustomerFormStyles;
const mapDispatchToProps = {
    becomeAcustomer,
};

type Props = WidgetProps &
    OwnProps &
    ResolveThunks<typeof mapDispatchToProps>;

const BecomeCustomerForm = ({
    becomeAcustomer,
}: Props) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        companyName: ""
    });
    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        companyName: ""
    });
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const validate = () => {
        const newErrors = { name: "", email: "", phoneNumber: "", companyName: "" };
        let isValid = true;
        
        if (!formData.name.trim()) {
            newErrors.name = translate("Name is required");
            isValid = false;
        }
        if (!formData.email.trim()) {
            newErrors.email = translate("Email is required");
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = translate("Invalid email format");
            isValid = false;
        }
        if (!formData.phoneNumber.trim()) {
            newErrors.phoneNumber = translate("Phone number is required");
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
            newErrors.phoneNumber = translate("Invalid phone number");
            isValid = false;
        }
        if (!formData.companyName.trim()) {
            newErrors.companyName = translate("Company name is required");
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleChange = (field: string, value: string) => {
        setFormData(prevState => ({ ...prevState, [field]: value }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [field]: "", 
        }));
    };

    const handleSubmit = () => {
        if (validate()) {
            becomeAcustomer({
                Properties:formData,
                onSuccess: () => {
                    setShowSuccessMessage(true);
                    setFormData({
                        name: "",
                        email: "",
                        phoneNumber: "",
                        companyName: ""
                    });
                },
                onError: error => {
                    setErrorMessage(error);
                    setShowErrorMessage(true);
                },
                onComplete(resultProps) {
                    if (resultProps.apiResult?.successful) {
                        this.onSuccess?.();
                    } else if (resultProps.apiResult?.errorMessage) {
                        this.onError?.(resultProps.apiResult.errorMessage);
                    }
                },
            });
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.headingWrapper}>
            <Typography as="h2" {...styles.headingText}>{siteMessage("GM_BecomeACustomerTitle_Msg")}</Typography>
            </StyledWrapper>
            <GridContainer {...styles.formFieldGridContainer} className="become-a-customer-form">
                <GridItem {...styles.formFieldGridItem}>
                    <TextField
                        className="form-field"
                        {...styles.formTextField}
                        label={translate("Your Name")}
                        value={formData.name}
                        onChange={e => handleChange("name", e.currentTarget.value)}
                        error={errors.name}
                        required
                    />
                </GridItem>
                <GridItem {...styles.formFieldGridItem}>
                    <TextField
                        className="form-field"
                        {...styles.formTextField}
                        label={translate("Email")}
                        value={formData.email}
                        onChange={e => handleChange("email", e.currentTarget.value)}
                        error={errors.email}
                        required
                    />
                </GridItem>
                <GridItem {...styles.formFieldGridItem}>
                    <TextField
                        className="form-field"
                        {...styles.formTextField}
                        label={translate("Phone")}
                        value={formData.phoneNumber}
                        onChange={e => handleChange("phoneNumber", e.currentTarget.value)}
                        error={errors.phoneNumber}
                        required
                    />
                </GridItem>
                <GridItem {...styles.formFieldGridItem}>
                    <TextField
                        className="form-field"
                        {...styles.formTextField}
                        label={translate("Company Name")}
                        value={formData.companyName}
                        onChange={e => handleChange("companyName", e.currentTarget.value)}
                        error={errors.companyName}
                        required
                    />
                </GridItem>
            </GridContainer>
            <StyledWrapper {...styles.buttonWrapper}>
                <Button {...styles.button} onClick={handleSubmit}>
                    {translate("Submit")}
                </Button>
                {showSuccessMessage && (
                    <StyledWrapper>
                        <Typography as="p" className="success-msg">{siteMessage("GM_BecomeACustomerSubmission_Msg")}</Typography>
                    </StyledWrapper>
                )}
                {showErrorMessage && (
                    <StyledWrapper>
                        <Typography as="p" className="error-msg">{errorMessage}</Typography>
                    </StyledWrapper>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null,mapDispatchToProps)(BecomeCustomerForm),
    definition: {
        group: "Common",
        displayName: "Become a Customer Form",
    },
};

export default widgetModule;
